/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type UpdateLimitMarginOrderMutationVariables = Types.Exact<{
	request: Types.UpdateLimitMarginOrderRequest;
}>;

export type UpdateLimitMarginOrderMutation = {
	__typename?: "Mutation";
	updateLimitMarginOrder?:
		| { __typename?: "MarginLimitOrderInProgressResponse" }
		| {
				__typename?: "MarginLimitOrderSuccessResponse";
				order: {
					__typename?: "MarginLimitOrder";
					id: string;
					assetId: string;
					status: Types.OrderStatus;
					amount: string;
					tradeType: Types.TradeType;
					exitOrderType: Types.ExitMarginOrderType;
					targetPrice: string;
					createdAt?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
				};
		  }
		| null;
};

export const UpdateLimitMarginOrderDocument = gql`
	mutation updateLimitMarginOrder($request: UpdateLimitMarginOrderRequest!) {
		updateLimitMarginOrder(request: $request) {
			... on MarginLimitOrderSuccessResponse {
				order {
					id
					assetId
					status
					amount
					tradeType
					exitOrderType
					targetPrice
					createdAt {
						iso8601
						unixTimestamp
					}
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class UpdateLimitMarginOrderGQLService extends Apollo.Mutation<
	UpdateLimitMarginOrderMutation,
	UpdateLimitMarginOrderMutationVariables
> {
	document = UpdateLimitMarginOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
